export enum PopupType {
  unset = "",
  Unfriend = "Unfriend",
  Share = "Share",
  ShareAchievement = "ShareAchievement",
  Logout = "Logout",
  DeleteAccount = "DeleteAccount",
  IOSInstall = "IOSInstall",
  DailyReward = "DailyReward",
  PurchaseAvatar = "PurchaseAvatar",
  PurchaseResult = "PurchaseResult",
  ReturnNotification = "ReturnNotification",
  CoachMark = "CoachMark",
}

export enum PopupPriority {
  lowest = -1,
  unset = 0,
  low = 1,
  medium = 2,
  high = 3,
}

export const popupWithPriority: {
  [key: string]: PopupPriority;
} = {
  [PopupType.unset]: PopupPriority.unset,
  [PopupType.Unfriend]: PopupPriority.unset,
  [PopupType.Share]: PopupPriority.unset,
  [PopupType.ShareAchievement]: PopupPriority.unset,
  [PopupType.Logout]: PopupPriority.unset,
  [PopupType.DeleteAccount]: PopupPriority.unset,
  [PopupType.IOSInstall]: PopupPriority.unset,
  [PopupType.DailyReward]: PopupPriority.low,
  [PopupType.PurchaseAvatar]: PopupPriority.unset,
  [PopupType.PurchaseResult]: PopupPriority.unset,
  [PopupType.ReturnNotification]: PopupPriority.unset,
  [PopupType.CoachMark]: PopupPriority.lowest,
};
